import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    messagesByMeeting: {},
    typingUsers: {},
};
const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setMessages(state, action) {
            state.messagesByMeeting[action.payload.meetingId] = action.payload.messages;
        },
        addMessage(state, action) {
            const mid = action.payload.meetingId;
            if (!state.messagesByMeeting[mid]) {
                state.messagesByMeeting[mid] = [];
            }
            // Avoid duplicates
            const exists = state.messagesByMeeting[mid].some((m) => m.id === action.payload.id);
            if (!exists) {
                state.messagesByMeeting[mid].push(action.payload);
            }
        },
        prependMessages(state, action) {
            const mid = action.payload.meetingId;
            if (!state.messagesByMeeting[mid]) {
                state.messagesByMeeting[mid] = [];
            }
            state.messagesByMeeting[mid] = [...action.payload.messages, ...state.messagesByMeeting[mid]];
        },
        setTyping(state, action) {
            const mid = action.payload.meetingId;
            if (!state.typingUsers[mid])
                state.typingUsers[mid] = [];
            if (!state.typingUsers[mid].includes(action.payload.userId)) {
                state.typingUsers[mid].push(action.payload.userId);
            }
        },
        clearTyping(state, action) {
            const mid = action.payload.meetingId;
            if (state.typingUsers[mid]) {
                state.typingUsers[mid] = state.typingUsers[mid].filter((id) => id !== action.payload.userId);
            }
        },
    },
});
export const { setMessages, addMessage, prependMessages, setTyping, clearTyping } = chatSlice.actions;
export default chatSlice.reducer;
